import * as React from 'react';
import { Button } from 'antd';
import { observer } from 'mobx-react-lite';
import { useAppStore } from '../../stores';
import { MoreActionsMenu } from '..';
import './AppHeader.less';

const AppHeader: React.FC = () => {
    const { appName, packageName, sessionStore, worksheetsSubmissionStore, controlStateStore } = useAppStore();

    const renderSelectedWorksheetCount = () => {
        if (!worksheetsSubmissionStore.selectiveModeEnabled) {
            return null;
        }

        const count = worksheetsSubmissionStore.worksheetsToProcess.length;

        return (
            <span className="selected-worksheet-count">
                {count} worksheet{count === 1 ? '' : 's'} selected
            </span>
        );
    };

    return (
        <div className="accounting-statement-app-header">
            <div className="left-container">
                <span className="application-name">{appName}</span>
                <span className="package-name">{packageName}</span>
            </div>

            {!sessionStore.isInitializing && !worksheetsSubmissionStore.isInitializing && (
                <div className="right-container">
                    {renderSelectedWorksheetCount()}
                    <MoreActionsMenu />
                    <Button
                        type="primary"
                        style={{ height: 40 }}
                        onClick={() => worksheetsSubmissionStore.processMultipleWorksheets()}
                        disabled={!worksheetsSubmissionStore.canProcessWorksheets || controlStateStore.actionsDisabled}
                    >
                        Send to SICS
                    </Button>
                </div>
            )}
        </div>
    );
};

export default observer(AppHeader);
